import React, { useEffect, useState } from "react";
import domain from "../../../config/domain";

const SignCheck = ({ onSuccess, onError }: any) => {
    const [token, setToken] = useState("");

    const fetchToken = () => {
        const apiUrl = domain.sdkSignatureUrl
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": "Iq0wt1I0D13WeEIlItpIY39LIDFC71I16kxv6uDk"
            },
            body: JSON.stringify({ key: "35sbze6VT3KS", clientName: "NUVAMA" }),
        };

        return fetch(apiUrl, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setToken(data.body);
                return data.body;
            })
            .catch((error) => {
                console.error("Error fetching token:", error);
                if (onError) onError(error);
            });
    };

    const handleSDKData = (data: any) => {
        if (onSuccess) onSuccess(data);
    };

    const initSDK = async () => {
        try {
            let finalToken = token;
            if (!token) {
                finalToken = await fetchToken();
            }
            if (finalToken) {
                (window as any).AinxtSDK.Initialize(finalToken, handleSDKData);
            }
        } catch (error) {
            if (onError) onError(error);
        }
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.src = domain.sdkSignatureScript;
        script.async = true;
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, []);


    useEffect(() => {
        initSDK();
    }, []);

    return null;
};

export default SignCheck;
